import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import config from 'config';

const libraries: ('drawing' | 'geometry' | 'places')[] = ['geometry', 'drawing', 'places'];

interface GoogleMapsLoaderContextType {
  isLoaded: boolean;
  loadError: Error | undefined;
}

const GoogleMapsLoaderContext = createContext<GoogleMapsLoaderContextType | null>(null);

export const useGoogleMapsLoader = (): GoogleMapsLoaderContextType => {
  const context = useContext(GoogleMapsLoaderContext);
  if (!context) {
    throw new Error('useGoogleMapsLoader must be used within GoogleMapsLoaderProvider');
  }
  return context;
};

interface GoogleMapsLoaderProviderProps {
  children: ReactNode;
}

export const GoogleMapsLoaderProvider = ({ children }: GoogleMapsLoaderProviderProps): React.ReactElement => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    googleMapsApiKey: (config as any).apiKeys.googleMap,
    libraries,
  });

  const contextValue = useMemo(() => ({ isLoaded, loadError }), [isLoaded, loadError]);

  return <GoogleMapsLoaderContext.Provider value={contextValue}>{children}</GoogleMapsLoaderContext.Provider>;
};
